import React from 'react';

const About = () => {
  return (
    <div className="container mt-5">
      <h1>About Us</h1>
      <p>Welcome to our e-commerce store! We are a leading provider of DDP (Delivered Duty Paid) services, ensuring seamless and hassle-free transactions for our customers. As a trusted reseller, importer, and exporter, we specialize in sourcing and delivering high-quality products from around the world.</p>
      
      <h2>How We Work</h2>
      <p>At the core of our business is a commitment to excellence and customer satisfaction. We manage every step of the process, from product sourcing to final delivery, ensuring that our customers receive their orders on time and in perfect condition. Our DDP services mean that we handle all customs duties and taxes, so you don't have to worry about any hidden fees.</p>
      <h2>Our Mission</h2>
      <p>To provide seamless global trade solutions while upholding the highest standards of quality, integrity, and customer satisfaction.</p>

      <h2>Our Services</h2>
      <ul>
        <li><strong>Reselling:</strong> We partner with top manufacturers and brands to bring you the best products at competitive prices.</li>
        <li><strong>Importing:</strong> We carefully select and import products from trusted suppliers worldwide, ensuring quality and authenticity.</li>
        <li><strong>Exporting:</strong> We help businesses expand their reach by exporting products to international markets, taking care of all the logistics.</li>
      </ul>
      
      <h2>Customer Commitment</h2>
      <p>We believe in building lasting relationships with our customers by providing personalized service and support. Whether you're purchasing a single item or managing a large order, our team is here to assist you every step of the way. We take pride in our transparent pricing, reliable delivery, and responsive customer service.</p>

      <p>If you have any questions or feedback, please don't hesitate to contact us. We're always here to help!</p>

      <h2>Contact Us</h2>
      <p><strong>Email:</strong> info@tglobal.store</p>
      <p><strong>Phone:</strong> +1 561 925 7771</p>
      
    </div>
  );
};

export default About;
